// extracted by mini-css-extract-plugin
export default {"SchoolRegistrationForm":"School_SchoolRegistrationForm__v2mZL","SchoolList":"School_SchoolList__ByDDx","Title":"School_Title__ZI7zC"};